import type { Components, Theme } from "@mui/material/styles";

export const MuiDialogTitle: Components<Theme>["MuiDialogTitle"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      alignItems: "center",
      backgroundColor: theme.palette.grey[300],
      display: "flex",
      fontSize: theme.spacing(2.5),
      fontWeight: theme.typography.fontWeightMedium,
      justifyContent: "space-between",
      lineHeight: 1.6,
      padding: theme.spacing(0.5, 1, 0.5, 2),
      textTransform: "capitalize",
    }),
  },
};
